import styled from '@emotion/styled'
import { wrapContained as withStyle, stylesIf } from 'utils/styles'
import { TIMER, COMPLEX, SINGLE_CONDITON_NODES } from 'utils/constants'

export default withStyle(
  (props) => `
    position: relative;
    border-radius: 8px;
    
    ${Overlay} {
      ${overlayConditions(props)}
    }
  `
)

export const StyledHeader = styled.header`
  width: 100%;
  line-height: 26px;
  height: 26px;
  padding-left: 10px;
  position: relative;
  pointer-events: none;

  p {
    margin-bottom: 0;
    line-height: inherit;
    color: inherit;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 5px;
    width: 90%;
  }
`

export const StyledContent = styled.div`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-size: 12px;
  width: calc(100% - 6px);
`

export const Overlay = styled.div`
  position: absolute;
  left: 0;
  right: -${({ isSimulating }) => (isSimulating ? 8 : 4)}px;
  bottom: 0;
  top: 0;
  border-radius: 8px;
  cursor: pointer;
`

const getFrameBorder = ({
  backgroundColor,
  frameColor,
  isSelected,
  hasErrors,
  isSimulating,
  isTimer,
  isOutput,
  outputting,
  isActivePowerNetLevel,
  finalGateSimulation,
  isNotSingleCondition,
  evaluation,
  virtualFuseOpen = false,
}) => {
  if (isSimulating) {
    const simBorderWidth = isSelected ? 3 : 2
    const simBorderStyle =
      (isTimer && outputting) ||
      (isOutput &&
        outputting &&
        isActivePowerNetLevel &&
        virtualFuseOpen === false) ||
      finalGateSimulation || // logic sets can have delays on their activate or deactivate, so their border relies on the final gate simulatoin value
      (!isNotSingleCondition && evaluation)
        ? 'solid'
        : 'dashed'
    return `
      border: ${simBorderWidth}px ${simBorderStyle} ${frameColor};
      ${stylesIf(
        isNotSingleCondition,
        `:hover {
          border: none;
        }`
      )}
    `
  }
  if (hasErrors) {
    return `box-shadow: 0 0 0 2px ${frameColor};`
  }
  if (outputting && !isActivePowerNetLevel) {
    return `box-shadow: 0 0 0 2px ${frameColor};`
  }
  return `box-shadow: 0 0 0 1px ${backgroundColor}, 0 0 0 2px ${frameColor};`
}

const getFrameColor = ({
  color,
  isSelected,
  markedForDeletion,
  isSimulating,
  hasErrors,
  outputting,
  isActivePowerNetLevel,
  finalGateSimulation,
  isTimer,
  isOutput,
  isNotSingleCondition,
  evaluation,
  virtualFuseOpen,
}) => {
  const {
    slateLight,
    errorPrimary,
    confirmPrimary,
    blueSecondary,
    warningPrimary,
  } = color
  if (hasErrors) {
    return warningPrimary
  }
  if (isSimulating) {
    if (isOutput && outputting && !isActivePowerNetLevel) {
      return errorPrimary
    }
    if (isOutput && outputting && virtualFuseOpen === true) return errorPrimary
    if (
      (isTimer && outputting) ||
      (isOutput && outputting) ||
      finalGateSimulation ||
      (!isNotSingleCondition && evaluation)
    ) {
      return confirmPrimary
    }
    return errorPrimary
  }
  if (isSelected) {
    return markedForDeletion ? errorPrimary : blueSecondary
  }
  return slateLight
}

const getBackgroundColor = ({ color, isSelected, type }) => {
  const { offWhite, whitePrimary, blueAvailable } = color

  if (isSelected) {
    return blueAvailable
  }
  if (type === TIMER || type !== COMPLEX) {
    return whitePrimary
  }
  return offWhite
}

const overlayConditions = (props) => {
  const {
    selectedId,
    type,
    uri,
    markedForDeletion,
    output,
    hasErrors,
    theme,
    isSimulating,
    finalGateSimulation,
    outputting,
    isActivePowerNetLevel,
    isTimer,
    isOutput,
    evaluation,
    virtualFuseOpen,
  } = props
  const { color, featureBorderHoveredColor } = theme

  const isNotSingleCondition = !SINGLE_CONDITON_NODES.has(type)
  const isSelected =
    selectedId === (uri || (output && output.id)) && isNotSingleCondition

  const frameColor = getFrameColor({
    color,
    isSelected,
    markedForDeletion,
    isSimulating,
    finalGateSimulation,
    hasErrors,
    isTimer,
    isOutput,
    outputting,
    isActivePowerNetLevel,
    isNotSingleCondition,
    evaluation,
    virtualFuseOpen,
  })

  const backgroundColor = getBackgroundColor({
    color,
    isSelected,
    type,
  })

  const hoverStyle = `
    &:hover {
      box-shadow: ${
        isSimulating ? 'inset' : ''
      } 0 0 0 2px ${featureBorderHoveredColor};
    }
  `

  const frameBorder = getFrameBorder({
    backgroundColor,
    frameColor,
    hasErrors,
    isSelected,
    isSimulating,
    outputting,
    finalGateSimulation,
    isTimer,
    isOutput,
    isNotSingleCondition,
    evaluation,
    isActivePowerNetLevel,
    virtualFuseOpen,
  })

  /* eslint-disable indent */
  return `
    background: ${backgroundColor};
    // fake a double border so sizing doesn't change
    // when selected/hover border is 2px
    ${frameBorder}
      
    ${stylesIf(
      isNotSingleCondition && !markedForDeletion && !hasErrors,
      hoverStyle
    )}

  `
}
